const textStyle = {
	color: 'secondary.main',
	fontWeight: '400',
	width: '100%',
	fontSize: '1.6rem',
}

export const styles = {
	btnConnect: {
		a: {
			borderRadius: 1,
			boxShadow: 'none',
			marginTop: '1.5rem',
		},
	},
	btnConnectHomeVariant: {
		textAlign: 'left',
	},
	btnConnectNotHomeVariant: {
		textAlign: 'center',
	},
	callToActionText: {
		...textStyle,
		fontSize: '3.4rem',
		'@media (max-width: 600px)': {
			fontSize: '2.4rem',
		},
	},
	callToActionTextHomeVariant: {
		textAlign: 'left',
		marginTop: '57px',
	},
	callToActionTextNotHomeVariant: {
		fontSize: '16px',
		textAlign: 'center',
	},
	ctaCaption: {
		...textStyle,
		fontSize: '2.4rem',
		'@media (max-width: 600px)': {
			fontSize: '1.4rem',
		},
	},
	ctaCaptionHomeVariant: {
		textAlign: 'left',
	},
	ctaCaptionNotHomeVariant: {
		textAlign: 'center',
		fontSize: '16px',
	},
	ctaContainer: {
		display: 'flex',
		flexDirection: 'row',
		margin: '0 auto',
		gap: '14rem',
		marginTop: '3.2rem',
		marginBottom: '3.2rem',
		'@media (max-width: 1024px)': {
			flexDirection: 'column',
			alignItems: 'center',
			gap: '6.6rem',
		},
		'@media (max-width: 600px)': {
			margin: '1rem auto',
			gap: '0rem',
			svg: {
				width: '100%',
			},
		},
	},
	ctaContainerHomeVariant: {
		justifyContent: 'left',
	},
	ctaContainerNotHomeVariant: {
		marginTop: '3.2rem',
		justifyContent: 'center',
	},
	ctaInnerContainer: {
		margin: 'auto',
	},
	ctaInnerContainerHomeVariant: {
		textAlign: 'left',
	},
	ctaInnerContainerNotHomeVariant: {
		textAlign: 'center',
	},
	ctaImage: {
		maxWidth: '100%',
	},
	ctaButton: {
		borderColor: 'rgba(25, 118, 210, 0.5)',
		color: '#45657B',
		padding: '8px 22px',
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: '26px',
		letterSpacing: '0.46px',
		'&:hover': {
			borderColor: 'rgba(25, 118, 210, 0.5)',
			backgroundColor: 'rgba(25, 118, 210, 0.04)',
		},
	},
}
